import { h } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Alert, Box, Button, Grid, Link, TextField, Typography } from "@mui/material";

import { ValidatePhoneVerificationCode } from "../Common/helpers";
export default function ConfirmPhone({ id, setUpperState }) {
	console.log("render ConfirmPhone");
	const [state, setState] = useState({});
	const [mode, setMode] = useState("resp");
	const [complete, setComplete] = useState(false);

	const handleChange = (event) => {
		setState({
			...state,

			[event.target.name]: event.target.value,
		});
	};

	useEffect(() => {
		console.log("useEffect1");
		setComplete(ValidatePhoneVerificationCode(state.n1));
	}, [state]);
	useEffect(() => {
		console.log("useEffect2");
		if (mode === "repOk") {
			setTimeout("location.reload(true);", 2000);
		}
	}, [mode]);

	const sendNewCode = () => {

		fetch("/api/001001")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//	setState({ phone1_checked: true });
						setMode("resp1");
						setState({
							...state,
							n1: "",
						});

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}

	const checkCode = (cd) => {
		console.log("checkCode", cd)
		setMode("resp");
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				code: cd !== undefined ? cd : state.n1,
			}),
		};
		fetch("/api/001002", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setMode("repOk");
						setState({
							...state,
							n1: "",
						});
						break;
					case "err":
						setMode("repNok");
						setState({
							...state,
							n1: "",
						});
						break;
					default:
						break;
				}
			});
	}
	return (
		<div style="padding: 0px;">
			<Box
				display="flex"
				alignItems="center"
				justifyContent="flex-start"
				//flexDirection="column"
				p={1}
				m={1}
				style="padding: 0px; margin: 0px;"
			>
				<Box >
					<div style="max-width: 600px; padding-left: 0px; padding-right: 30px;">
						<Grid container>
							<Grid item xs={12}>
								{mode === "resp1" && <Typography variant="h5">Le code a été renvoyé</Typography>}
							</Grid>
							<Grid item xs={12}>
								{["resp", "resp1", "repNok"].includes(mode) && (
									<TextField
										id="n1"
										name="n1"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										size="small"
										margin="dense"
										fullWidth
										placeholder="XXXXXX"

										value={state.n1}
										onChange={handleChange}
									/>
								)}
								{mode === "repOk" && <Alert severity="success">Votre code est validé</Alert>}
								{mode === "repNok" && <Alert severity="error">Votre code n'est pas validé</Alert>}
							</Grid>

							{mode !== "repOk" && (
								<Grid item xs={12}>
									<Box display="flex" justifyContent="space-between" alignItems="center">
										<Box>
											{/* <span onClick={() => {
												checkCode("3874465");
											}}>&nbsp;&nbsp;</span> */}
											<Link onClick={() => sendNewCode()}
												underline="none" style="margin-left: 0px; cursor: pointer">{mode === "req" ? "Envoyer un code" : "Renvoyer un code"}
											</Link>

										</Box>
										<Box>
											<Button
												variant="contained"

												disabled={!complete}
												onClick={() => checkCode(state.n1)}
											>
												Confirmer
											</Button>
										</Box>
									</Box>
								</Grid>
							)}
						</Grid>
					</div>
				</Box>
			</Box>
		</div >
	);
}
